document.addEventListener('DOMContentLoaded', () => {
  console.log("### Loading Custom Logic");
  cookMode();
});


function cookMode() {
    const $root = $('.c-cook-mode')
    let screenLock = null
    let isSelected = false
    if (!$root) {
        return
    }
    const $toggler = $root.find('.cook-mode-toggle')
    const prependElement = $('.shg-c .shg-c .shg-c .shogun-heading-component')
    
    $root.detach().insertBefore(prependElement.last())
    
    $toggler.click(() => {
        if (!isSelected) {
            initScreenLock()
            isSelected = true
            $toggler.addClass('active')
        } else {
            removeScreenLock()
            isSelected = false
            $toggler.removeClass('active')
        }
    })

    async function initScreenLock() {
        try {
            screenLock = await navigator.wakeLock.request('screen')
            screenLock.addEventListener('release', () => {
                isSelected = false
            })
        } catch (err) {
            console.log(err.name, err.message)
        }
    }
    async function removeScreenLock() {
        await screenLock.release()
        screenLock = null
    }
}

// Custom script to delay verification popup
// Load this after your main VerificationPopup.js

document.addEventListener('DOMContentLoaded', function() {
  // Override the original load method with a delayed version
  const verificationElements = document.querySelectorAll('[data-verification-popup]');
  
  verificationElements.forEach(element => {
    // Check if the element has a VerificationPopup instance
    if (element._verificationPopup && element._verificationPopup.load) {
      const originalLoad = element._verificationPopup.load;
      
      // Override the load method
      element._verificationPopup.load = function() {
        // Get delay from data attribute or default to 2 seconds
        const delay = parseInt(element.dataset.ageDelay, 10) || 2000;
        
        // Age checker is in test mode - will show immediately in editor and on live site
        if (this.ageTestMode) {
          this.showModal();
          return;
        }
        
        if (this.modalLinks) {
          this.modalLinks.setAttribute('tabindex', '1');
        }
        
        // Add delay to allow cookie banner to load first
        setTimeout(() => {
          var isAnAdult = this.readCookie('isAnAdult');
          if (!isAnAdult) {
            if (window.Shopify.designMode && !this.ageTestMode) return;
            this.showModal();
          }
        }, delay);
        
        // Set up event listeners immediately
        if (this.enterButton) {
          this.enterButton.addEventListener('click', this.writeCookie);
        }
        if (this.exitButton) {
          this.exitButton.addEventListener('click', this.comeBackModal);
        }
        if (this.returnButton) {
          this.returnButton.addEventListener('click', this.confirmAgeModal);
        }
      };
      
      // Re-initialize with the new load method
      element._verificationPopup.load();
    }
  });
});
